import { render, staticRenderFns } from "./ImportsTable.vue?vue&type=template&id=a31d522c&"
import script from "./ImportsTable.vue?vue&type=script&lang=ts&"
export * from "./ImportsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports